import { useState, useEffect } from 'react';
import { otpVerificaionApi, forgotPassApi } from '../../Service/ApiService';
import { useNavigate, useLocation } from 'react-router-dom';
// import { showSuccessAlert } from 'utils/SuccessMessage';

const useOTPVerificationController = (initialState, validate) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { mobile, usercode, your_otp } = location.state || {};

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(60); // 1 minute
  const [canResend, setCanResend] = useState(false);
  const [OTP, setOTP] = useState('');

  useEffect(() => {
    setOTP(your_otp);
  }, []);

  const handleChange = (e) => {
    let inputValue = e.target.value;

    if (e.target.name === 'otp') {
      const OTPValue = inputValue.replace(/[^0-9]/g, '').slice(0, 6);
      setFormData({ ...formData, [e.target.name]: OTPValue });
      setErrors({ ...errors, [e.target.name]: '' });
      return;
    }

    setFormData({ ...formData, [e.target.name]: inputValue });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleOTPverify = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        const response = await otpVerificaionApi(mobile, usercode, formData.otp);
        if (response.success) {
          // showSuccessAlert(response.msg, 'Message');
          navigate('/reset-password', { state: { usercode } });
        } else {
          setApiError(response.msg);
        }
      } catch (error) {
        setApiError('Something went wrong!');
      } finally {
        setLoading(false);
      }
    }
  };

  const resendOTP = async () => {
    try {
      setLoading(true);
      const response = await forgotPassApi(mobile, usercode);
      if (response.success) {
        setOTP(response.data.otp);
        // showSuccessAlert(response.msg, 'Message');
        setResendTimer(60); // reset timer
        setCanResend(false);
      } else {
        setApiError(response.msg);
      }
    } catch (error) {
      setApiError('Something went wrong!');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Only start timer if resend is not allowed
    if (canResend) return;

    const interval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResend(true); // enable resend after timer ends
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [canResend]);


  // Format timer to mm:ss
  const formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  };

  return {
    OTP,
    formData,
    errors,
    apiError,
    loading,
    handleChange,
    handleOTPverify,
    resendOTP,
    canResend,
    resendTimer,
    formatTimer,
  };
};

export default useOTPVerificationController;
